import React, { useState } from "react";
import Page from "../2/Controls/Page";
import Loader from "../Loader";
import axios from "axios";
import Input from "../2/Controls/Input";

function PincodeWarehouseIntegration() {
  const [storeCode, setStoreCode] = useState("");
  const [customerCode, setCustomerCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState([
    { name: "Flags", status: "pending", message: "" },
    { name: "Transaction Type Creation", status: "pending", message: "" },
    { name: "Catalog Sync", status: "pending", message: "" },
  ]);

  const updateProgress = (index, status, message = "") => {
    setProgress((prev) =>
      prev.map((item, i) => (i === index ? { ...item, status, message } : item))
    );
  };

  const handleConvert = async () => {
    if (!storeCode.trim() || !customerCode.trim()) {
      alert("Please enter both Posible Store ID and Wharehouse Customer Code.");
      return;
    }

    setLoading(true);
    setProgress([
      { name: "Flags", status: "pending", message: "" },
      { name: "Transaction Type Creation", status: "pending", message: "" },
      { name: "Catalog Sync", status: "pending", message: "" },
    ]);

    try {
      // Example API calls (replace URLs with your real ones)
      const apis = [
        {
          name: "Flags",
          url:
            "https://pincodebackgroundprocess-706168875042.asia-south1.run.app/warehouse/integration/enable/flags",
          payload: { storeId: storeCode, customerCode },
        },
        {
          name: "Transaction Type Creation",
          url:
            "https://pincodebackgroundprocess-706168875042.asia-south1.run.app/warehouse/integration/transactiontype",
          payload: { storeId: storeCode },
        },
        {
          name: "Catalog Sync",
          url:
            "https://pincodebackgroundprocess-706168875042.asia-south1.run.app/warehouse/integration/sync",
          payload: { storeId: storeCode },
        },
      ];

      // Sequential call (one after another)
      for (let i = 0; i < apis.length; i++) {
        const { name, url, payload } = apis[i];
        updateProgress(i, "running", "Processing...");
        try {
          const res = await axios.post(url, payload);
          console.log(res);
          updateProgress(i, "success", JSON.stringify(res.data.message));
        } catch (error) {
          updateProgress(
            i,
            "error",
            error.response.data.message || error.message
          );
        }
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Page
      title="Convert to Smart Store"
      showSaveButton={false}
      showCancelButton={false}
      processing={loading}
    >
      {loading && <Loader show={loading} />}

      <div
        style={{
          padding: "20px",
          fontFamily: "Arial, sans-serif",
          maxWidth: "600px",
          margin: "0 auto",
        }}
      >
        {/* --- Input Fields --- */}
        <div style={{ marginBottom: "20px" }}>
          {/* <label style={{ display: "block", marginBottom: "8px" }}>
            Store ID:
          </label> */}
          <Input
            type="text"
            label="Posible Store ID"
            value={storeCode}
            onChange={(value) => {
              setStoreCode(value);
            }}
            placeholder="Enter Posible Store ID"
            style={{
              width: "100%",
              padding: "10px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        </div>

        <div style={{ marginBottom: "20px" }}>
          {/* <label style={{ display: "block", marginBottom: "8px" }}>
            Customer Code:
          </label> */}
          <Input
            type="text"
            label="Warehouse Customer Code"
            value={customerCode}
            onChange={(value) => {
              setCustomerCode(value);
            }}
            placeholder="Enter Warehouse Customer Code"
            style={{
              width: "100%",
              padding: "10px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        </div>

        {/* --- Convert Button --- */}
        <button
          onClick={handleConvert}
          disabled={loading}
          style={{
            padding: "12px 24px",
            backgroundColor: "#1976d2",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            width: "100%",
            fontSize: "16px",
          }}
        >
          {loading ? "Processing..." : "Convert to Smart Store"}
        </button>

        {/* --- Progress Section --- */}
        <div style={{ marginTop: "30px" }}>
          <h3>Progress</h3>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#f0f0f0" }}>
                <th style={{ padding: "10px", textAlign: "left" }}>API</th>
                <th style={{ padding: "10px", textAlign: "left" }}>Status</th>
                <th style={{ padding: "10px", textAlign: "left" }}>Message</th>
              </tr>
            </thead>
            <tbody>
              {progress.map((step, i) => (
                <tr key={i}>
                  <td style={{ padding: "10px" }}>{step.name}</td>
                  <td
                    style={{
                      padding: "10px",
                      color:
                        step.status === "success"
                          ? "green"
                          : step.status === "error"
                          ? "red"
                          : step.status === "running"
                          ? "orange"
                          : "gray",
                    }}
                  >
                    {step.status.toUpperCase()}
                  </td>
                  <td style={{ padding: "10px", wordBreak: "break-word" }}>
                    {step.message || "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Page>
  );
}

export default PincodeWarehouseIntegration;
